import type { JobWorkflowEntityType, JobWorkflowTransition } from '@/types'

export function getWorkflowTransitionLabel(transition: JobWorkflowTransition) {
  return transition.to_status_label || transition.to_status_code || String(transition.to_status)
}

export function workflowTransitionRequiresReason(transition: JobWorkflowTransition) {
  return Boolean(transition.to_status_reason_required)
    || String(transition.to_status_code || '').toLowerCase() === 'cancelled'
}

export function workflowTransitionRequiresNote(transition: JobWorkflowTransition) {
  return workflowTransitionRequiresReason(transition) || Boolean(transition.requires_note)
}

export function workflowEntityLabel(entityType?: JobWorkflowEntityType | null) {
  switch (entityType) {
    case 'assignment':
      return 'Assignment'
    case 'job':
      return 'Job'
    case 'workday_entry':
      return 'Work day entry'
    case 'booking':
      return 'Booking'
    default:
      return 'Record'
  }
}
